import { Dispatch, Action } from 'redux';
import axios from 'axios';
import { User } from '../reducers/users.reducer'
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
// import { NotificationManager } from 'react-notifications';
import { getUserAPI, getUsersAPI, addUserAPI, editUserAPI, deleteUserAPI } from '../../config/config'


// Action types
export const GET_USERS_REQUEST = 'GET_USERS_REQUEST';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const GET_USERS_FAILURE = 'GET_USERS_FAILURE';

export const GET_USER_REQUEST = 'GET_USER_REQUEST';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_FAILURE = 'GET_USER_FAILURE';

export const ADD_USER_REQUEST = 'ADD_USER_REQUEST';
export const ADD_USER_SUCCESS = 'ADD_USER_SUCCESS';
export const ADD_USER_FAILURE = 'ADD_USER_FAILURE';

export const EDIT_USER_REQUEST = 'EDIT_USER_REQUEST';
export const EDIT_USER_SUCCESS = 'EDIT_USER_SUCCESS';
export const EDIT_USER_FAILURE = 'EDIT_USER_FAILURE';

export const DELETE_USER_REQUEST = 'DELETE_USER_REQUEST';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_FAILURE = 'DELETE_USER_FAILURE';

export const SET_ADD_USER_POPUP = 'SET_ADD_USER_POPUP';
export const SET_EDIT_USER_POPUP = 'SET_EDIT_USER_POPUP';
export const SET_DELETE_USER_POPUP = 'SET_DELETE_USER_POPUP';

export const RESET_USER_STATE = 'RESET_USER_STATE'

export interface AddUserProps {
  firstName: string;
  lastName: string;
  email: string;
  companyUuid: string;
  teamUuid: string;
  userType: string
}

export interface EditUserProps {
  firstName: string;
  lastName: string;
  email: string;
  companyUuid: string;
  teamUuid: string;
  userType: string
}

interface DeleteUserProps {
  target: string | number;
}

interface GetUsersRequest extends Action<typeof GET_USERS_REQUEST> { }
interface GetUsersSuccess extends Action<typeof GET_USERS_SUCCESS> {
  payload: User[]
}
interface GetUsersFailure extends Action<typeof GET_USERS_FAILURE> {
  payload: string
}

interface GetUserRequest extends Action<typeof GET_USER_REQUEST> { }
interface GetUserSuccess extends Action<typeof GET_USER_SUCCESS> {
  payload: User
}
interface GetUserFailure extends Action<typeof GET_USER_FAILURE> {
  payload: string
}

interface AddUserRequest extends Action<typeof ADD_USER_REQUEST> { }
interface AddUserSuccess extends Action<typeof ADD_USER_SUCCESS> { }
interface AddUserFailure extends Action<typeof ADD_USER_FAILURE> {
  payload: string
}

interface EditUserRequest extends Action<typeof EDIT_USER_REQUEST> { }
interface EditUserSuccess extends Action<typeof EDIT_USER_SUCCESS> { }
interface EditUserFailure extends Action<typeof EDIT_USER_FAILURE> {
  payload: string
}

interface DeleteUserRequest extends Action<typeof DELETE_USER_REQUEST> { }
interface DeleteUserSuccess extends Action<typeof DELETE_USER_SUCCESS> { }
interface DeleteUserFailure extends Action<typeof DELETE_USER_FAILURE> {
  payload: string
}

interface SetAddPLanPopUp extends Action<typeof SET_ADD_USER_POPUP> {
  payload: boolean;
}

interface SetEditPLanPopUp extends Action<typeof SET_EDIT_USER_POPUP> {
  payload: boolean;
}

interface SetDeletePLanPopUp extends Action<typeof SET_DELETE_USER_POPUP> {
  payload: boolean;
}

interface ResetUserState extends Action<typeof RESET_USER_STATE> {}

export type ActionTypes = GetUsersRequest | GetUsersSuccess | GetUsersFailure
  | GetUserRequest | GetUserSuccess | GetUserFailure
  | AddUserRequest | AddUserSuccess | AddUserFailure
  | EditUserRequest | EditUserSuccess | EditUserFailure
  | DeleteUserRequest | DeleteUserSuccess | DeleteUserFailure
  | SetAddPLanPopUp | SetEditPLanPopUp | SetDeletePLanPopUp
  | ResetUserState

// Action creators
const getUsersRequest = (): GetUsersRequest => ({ type: GET_USERS_REQUEST });
const getUsersSuccess = (data: User[]): GetUsersSuccess => ({ type: GET_USERS_SUCCESS, payload: data });
const getUsersFailure = (error: string): GetUsersFailure => ({ type: GET_USERS_FAILURE, payload: error });

const getUserRequest = (): GetUserRequest => ({ type: GET_USER_REQUEST });
const getUserSuccess = (data: User): GetUserSuccess => ({ type: GET_USER_SUCCESS, payload: data });
const getUserFailure = (error: string): GetUserFailure => ({ type: GET_USER_FAILURE, payload: error });

const addUserRequest = (): AddUserRequest => ({ type: ADD_USER_REQUEST });
const addUserSuccess = (): AddUserSuccess => ({ type: ADD_USER_SUCCESS });
const addUserFailure = (error: string): AddUserFailure => ({ type: ADD_USER_FAILURE, payload: error });

const editUserRequest = (): EditUserRequest => ({ type: EDIT_USER_REQUEST });
const editUserSuccess = (): EditUserSuccess => ({ type: EDIT_USER_SUCCESS });
const editUserFailure = (error: string): EditUserFailure => ({ type: EDIT_USER_FAILURE, payload: error });

const deleteUserRequest = (): DeleteUserRequest => ({ type: DELETE_USER_REQUEST });
const deleteUserSuccess = (): DeleteUserSuccess => ({ type: DELETE_USER_SUCCESS });
const deleteUserFailure = (error: string): DeleteUserFailure => ({ type: DELETE_USER_FAILURE, payload: error });

const setAddUserPopup = (value: boolean): SetAddPLanPopUp => ({ type: SET_ADD_USER_POPUP, payload: value });
const setEditUserPopup = (value: boolean): SetEditPLanPopUp => ({ type: SET_EDIT_USER_POPUP, payload: value });
const setDeleteUserPopup = (value: boolean): SetDeletePLanPopUp => ({ type: SET_DELETE_USER_POPUP, payload: value });

const resetUserState = (): ResetUserState => ({type:RESET_USER_STATE})


// Async action creators
const getUsers = (params?:any) => {
  return async (dispatch: Dispatch) => {
    try {
      dispatch(resetUserState()); // Clear users state before fetching new data
      dispatch(getUsersRequest());
      let query = ''
      if(params){
          Object.keys(params)?.map((key, i)=>{
              if(i===0){
                  query = `?${key}=${params[key]}`
              }else{
                  query = query + `&${key}=${params[key]}`
              }
          })
      }
      
      const response = await getUsersAPI(query)
      const users = response?.data?.users || [];
      users.forEach((user:any) => {
        const teamPrivilegeLevel = user.teams[0].TeamUsers.privilegeLevel;
        user.userType = teamPrivilegeLevel === 1 ? 'MEMBER' : teamPrivilegeLevel === 2 ? 'LEAD' : teamPrivilegeLevel === 3 ? 'ADMIN' : 'OWNER';
        user.teamUuid = user.teams[0].uuid;
        user.userTeam = user.teams[0].name;
      });
      dispatch(getUsersSuccess(users))

    } catch (error: any) {
      console.log('error', error)
      //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
      dispatch(getUsersFailure(error.message));
    }
  };
};

const getUser = (uuid: string) => {
  return async (dispatch: Dispatch) => {
    try {
      dispatch(getUserRequest());
      const response = await getUserAPI(uuid)
      dispatch(getUserSuccess(response?.data?.company || {}))

    } catch (error: any) {
      console.log('error', error)
      //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
      dispatch(getUserFailure(error.message));
    }
  };
};

const addUser = (data: AddUserProps): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    try {
      dispatch(addUserRequest());

      const response = await addUserAPI(data)
      dispatch(addUserSuccess());
      dispatch(getUsers({uuid:data?.companyUuid})); // Call the getUsers action after adding a user
      dispatch(setAddUserPopup(false))
    } catch (error: any) {
      console.log('error', error);
      //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
      dispatch(addUserFailure(error.message));
    }
  };
};

const editUser = (data: AddUserProps, uuid: string): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  const token = window.localStorage.getItem('token');
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    try {
      dispatch(editUserRequest());
      const response = await editUserAPI(data, uuid)
      dispatch(editUserSuccess());
      dispatch(getUsers({uuid:data?.companyUuid})); // Call the getUsers action after adding a user
      dispatch( updateEditUserPopup(false))
    } catch (error: any) {
      console.log('error', error);
      //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
      dispatch(editUserFailure(error.message));
    }
  };
};

const deleteUser = (uuid: string, cUuid: string): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    try {
      dispatch(deleteUserRequest());
      const response = await deleteUserAPI(uuid)
      dispatch(deleteUserSuccess());
      dispatch(getUsers(cUuid)); // Call the getUsers action after adding a user
      dispatch(updateDeleteUserPopup(false))
    } catch (error: any) {
      console.log('error', error);
      //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
      dispatch(deleteUserFailure(error.message));
    }
  };
};

const updateAddUserPopup = (value: boolean): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    dispatch(setAddUserPopup(value))
  };
}

const updateEditUserPopup = (value: boolean): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    dispatch(setEditUserPopup(value))
  };
}

const updateDeleteUserPopup = (value: boolean): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    dispatch(setDeleteUserPopup(value))
  };
}

const resetAll = (): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    dispatch(resetUserState())
  };
}


const actions = {
  getUsers,
  addUser,
  editUser,
  getUser,
  deleteUser,
  updateAddUserPopup,
  updateEditUserPopup,
  updateDeleteUserPopup,
  resetAll
}

export default actions
